import React, {useContext, useEffect, useState} from 'react';
import {run} from "@/lib/axios";

import InstallerContext from "@/context/InstallerContext";

import Installing from "@/components/Installing";
import Completed from "@/components/Completed";
import InstallingError from "@/components/InstallingError";

const Finish = ({isActive}) => {
  const {data} = useContext(InstallerContext);
  const {apiKey, game, loginProvider, admin} = data;
  const [completed, setCompleted] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  
  useEffect(() => {
    if (isActive) {
      run(apiKey, game, loginProvider, admin)
          .then(({data}) => {
            if (data.success) {
              setCompleted(true);
            } else {
              setError(true);
              setErrorMessages(data.errors);
              console.log(data);
            }
          })
          .catch((error) => {
            setError(true);
            console.log(error);
          });
    }
  }, [isActive, data]);
  
  if (error)
    return <InstallingError messages={errorMessages}/>;
  
  if (!completed)
    return <Installing/>;
  
  return <Completed/>;
};

export default Finish;